import { getPathNameWithoutLangPrefix, isUserInGracePeriod } from '@intigral/utils';
import { remove } from '@intigral/utils/lib/browser-storage/localStorage';
import { showUpdatePayment } from '@intigral/utils/lib/user/ui';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GRACE_PERIOD_HOME_POPUP_DISMISSED_KEY, ROUTE_CONSTANT } from '../config/constants';
import { isGuestUser } from '../config/guestMode';
import user from '../helpers/user';
import { IStore } from '../interfaces/StoreTypes';
import { showUpgradedModal } from '../store/reducers/generalConfigurationSlice';

const shownByProfileGuid = new Set<string>();

const isHomePath = (pathname: string) => {
    const path = getPathNameWithoutLangPrefix(pathname);
    return path === '' || path === ROUTE_CONSTANT.KIDS_HOME;
};

/** On home / kids-home, opens UpgradeConfirmModal for grace-period users via showUpgradedModal. */
export const GracePeriodHomePopup = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const profile = useSelector((store: IStore) => store.profile);
    const subscriptionRev = useSelector((store: IStore) => store.user?.subscriptionRev);
    const profileGuid = profile?.selectedProfile?.profileGuid;

    useEffect(() => {
        remove(GRACE_PERIOD_HOME_POPUP_DISMISSED_KEY);
    }, []);

    useEffect(() => {
        if (!profileGuid || shownByProfileGuid.has(profileGuid)) {
            return;
        }

        const userInfo = user.getUserInfo();
        const shouldShow =
            isHomePath(location.pathname) &&
            !isGuestUser(userInfo) &&
            !showUpdatePayment(userInfo) &&
            isUserInGracePeriod();

        if (!shouldShow) {
            return;
        }

        shownByProfileGuid.add(profileGuid);
        dispatch(showUpgradedModal(true));
    }, [location.pathname, profileGuid, subscriptionRev, dispatch]);

    return null;
};
